<template>
  <section>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>
    <Customer :groom-or-bride="1"/>
  </section>
</template>

<script>
import Customer from '@/components/Customer'

export default {
  components: {
    Customer
  },
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'groom-customer' }
    }
  },
}
</script>
